import { render } from "./OperatorDashboard.vue?vue&type=template&id=2bb17faf&scoped=true"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js"

import "./OperatorDashboard.vue?vue&type=style&index=0&id=2bb17faf&scoped=true&lang=css"

import exportComponent from "D:\\fromUbuntu2\\fromUbuntu\\ferraro\\ferraro_frontend\\node_modules\\.pnpm\\vue-loader@16.8.3_webpack@4.46.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb17faf"]])

export default __exports__